/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface LeaderboardParticipationConfigResponse
 */
export interface LeaderboardParticipationConfigResponse {
    /**
     * 
     * @type {boolean}
     * @memberof LeaderboardParticipationConfigResponse
     */
    autoEnrollOnFirstEvent: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof LeaderboardParticipationConfigResponse
     */
    requireExplicitJoin: boolean;
    /**
     * 
     * @type {number}
     * @memberof LeaderboardParticipationConfigResponse
     */
    maxParticipants?: number;
}

/**
 * Check if a given object implements the LeaderboardParticipationConfigResponse interface.
 */
export function instanceOfLeaderboardParticipationConfigResponse(value: object): value is LeaderboardParticipationConfigResponse {
    if (!('autoEnrollOnFirstEvent' in value) || value['autoEnrollOnFirstEvent'] === undefined) return false;
    if (!('requireExplicitJoin' in value) || value['requireExplicitJoin'] === undefined) return false;
    return true;
}

export function LeaderboardParticipationConfigResponseFromJSON(json: any): LeaderboardParticipationConfigResponse {
    return LeaderboardParticipationConfigResponseFromJSONTyped(json, false);
}

export function LeaderboardParticipationConfigResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): LeaderboardParticipationConfigResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'autoEnrollOnFirstEvent': json['autoEnrollOnFirstEvent'],
        'requireExplicitJoin': json['requireExplicitJoin'],
        'maxParticipants': json['maxParticipants'] == null ? undefined : json['maxParticipants'],
    };
}

export function LeaderboardParticipationConfigResponseToJSON(json: any): LeaderboardParticipationConfigResponse {
    return LeaderboardParticipationConfigResponseToJSONTyped(json, false);
}

export function LeaderboardParticipationConfigResponseToJSONTyped(value?: LeaderboardParticipationConfigResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'autoEnrollOnFirstEvent': value['autoEnrollOnFirstEvent'],
        'requireExplicitJoin': value['requireExplicitJoin'],
        'maxParticipants': value['maxParticipants'],
    };
}

